/* eslint-env node, browser */
/**
 * 超级会员延期前端提交上下文工具。
 * 纯函数便于 Node 回归：确认时冻结 payload，回调按客户代次/提交代次忽略迟到结果，
 * 超时回读失败时不自动重试。
 */
(function (root, factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        root.VipExtensionSubmit = factory();
    }
}(typeof self !== 'undefined' ? self : this, function () {
    function createSubmitContext(input) {
        var payload = Object.assign({}, input.payload);
        return {
            customerId: input.customerId,
            generation: input.generation,
            submitVersion: input.submitVersion,
            requestId: payload.requestId,
            payload: Object.freeze(payload),
            retried: false,
            inFlight: false
        };
    }

    function isCurrentSubmit(submit, current) {
        return !!submit && !!current &&
            submit.customerId === current.customerId &&
            submit.generation === current.generation &&
            submit.submitVersion === current.submitVersion;
    }

    /**
     * 超时回读后的决策：
     * - already：已成功；
     * - retry：同客户、同代次、同快照且仍符合资格；
     * - reconfirm：资格/快照变化，必须重新确认；
     * - wait：回读失败或上下文已切换，不得自动重试。
     */
    function decideAfterRead(read) {
        if (!read || !read.ok || !read.current) {
            return 'wait';
        }
        if (read.compensated) {
            return 'already';
        }
        if (!read.eligible || !read.snapshotToken ||
            read.snapshotToken !== read.submit.payload.snapshotToken) {
            return 'reconfirm';
        }
        return 'retry';
    }

    return {
        createSubmitContext: createSubmitContext,
        isCurrentSubmit: isCurrentSubmit,
        decideAfterRead: decideAfterRead
    };
}));
